import Flickity from 'flickity';

export function gallery() {
	document.querySelectorAll('.js-gallery').forEach(elem => createGallery(elem));
}

function createGallery(element) {
	let main = element.querySelector('.js-gallery-main');
	let thumbs = element.querySelectorAll('.js-gallery-thumb');

	let flkty = new Flickity(main, {
		pageDots: false,
		prevNextButtons: false,
		percentPosition: false,
		wrapAround: true,
		adaptiveHeight: true,
	});

	for (let i = 0; i < thumbs.length; i++) {
		thumbs[i].onclick = function() {
			flkty.select(i);
		};
	}
}
